const isDev = __DEV__;

export function seriesCacheKey(seriesId: string | number, campaignId: string): string {
  const normalizedSeriesId = String(seriesId);

  if (isDev && !campaignId) {
    console.error('[CACHE-KEYS] campaignId is required for seriesCacheKey but was empty/null');
  }

  return `@series_metadata_${campaignId}_${normalizedSeriesId}`;
}

export function episodesCacheKey(seriesId: string | number, campaignId: string): string {
  const normalizedSeriesId = String(seriesId);

  if (isDev && !campaignId) {
    console.error('[CACHE-KEYS] campaignId is required for episodesCacheKey but was empty/null');
  }

  return `@episodes_${campaignId}_${normalizedSeriesId}`;
}

export function normalizeId(id: string | number): string {
  return String(id);
}

export function normalizeIds(ids: (string | number)[]): string[] {
  return ids.map(id => String(id));
}
